import { apiRequest } from "./api";

export type BillingPeriod = "month" | "year" | "none";

export interface PlanDefinition {
  id: string;
  audience: string; // "athlete" | "club"
  code: string;
  name: string;
  description: string | null;
  price_cents: number; // monthly (primary) price
  price_cents_year: number | null; // optional annual price
  currency: string;
  billing_period: BillingPeriod;
  features: string[] | null;
  stripe_product_id: string | null;
  stripe_price_id: string | null;
  stripe_price_id_year: string | null;
  is_active: boolean;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export interface PlanPayload {
  audience?: string;
  code?: string;
  name?: string;
  description?: string | null;
  price_cents?: number;
  price_cents_year?: number | null;
  currency?: string;
  billing_period?: BillingPeriod;
  features?: string[] | null;
  is_active?: boolean;
  sort_order?: number;
}

export async function getAthletePlans(): Promise<PlanDefinition[]> {
  const data = await apiRequest<{ plans: PlanDefinition[] }>("/admin/plans", {
    params: { audience: "athlete" },
  });
  return data.plans;
}

export async function getClubPlans(): Promise<PlanDefinition[]> {
  const data = await apiRequest<{ plans: PlanDefinition[] }>("/admin/plans", {
    params: { audience: "club" },
  });
  return data.plans;
}

export async function createPlan(payload: PlanPayload & { audience: string }): Promise<PlanDefinition> {
  const data = await apiRequest<{ plan: PlanDefinition }>("/admin/plans", { method: "POST", data: payload });
  return data.plan;
}

export async function updatePlan(id: string, payload: PlanPayload): Promise<PlanDefinition> {
  const data = await apiRequest<{ plan: PlanDefinition }>(`/admin/plans/${id}`, { method: "PATCH", data: payload });
  return data.plan;
}

/** Soft-disable a plan (server sets is_active=false; never hard-deletes). */
export async function disablePlan(id: string): Promise<void> {
  await apiRequest(`/admin/plans/${id}`, { method: "DELETE" });
}
